import type { PercentageCirclePieChartOption } from './types';

export const BASE_PERCENTAGE_PIE_CHART_OPTIONS: PercentageCirclePieChartOption = {
  // animation: false,
  series: [
    {
      name: 'Access From',
      type: 'pie',
      center: ['50%', '100%'],
      radius: ['150%', '200%'],
      startAngle: 180,
      // hoverAnimation: false,
      silent: true,
      label: {
        show: false,
      },
      emphasis: {
        label: {
          show: false,
        },
      },
      labelLine: {
        show: false,
      },
      data: [
        {
          value: 0,
          name: 'actual1',
          itemStyle: {
            color: '#376AE7',
          },
        },
        {
          value: 0,
          name: 'actual2',
          itemStyle: {
            color: '#f2f3f5',
          },
        },
        {
          value: 2,
          name: 'splitter',
          itemStyle: {
            color: '#fff',
          },
        },
        {
          value: 0,
          name: 'extra1',
          itemStyle: {
            color: '#77E097',
          },
        },
        {
          value: 0,
          name: 'extra2',
          itemStyle: {
            color: '#f2f3f5',
          },
        },
        {
          value: 132,
          name: 'mask',
          itemStyle: {
            color: 'transparent',
          },
        },
      ],
    },
  ],
};
